
import { Component, Vue, Provide, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import leftmode from "./components/left/mode.vue"
import centermode from "./components/center/mode.vue"
import rightmode from "./components/right/mode.vue"
import ChoosePages from '@/components/choosepages/choosepages.vue';
import {
	custompagecustompagesave,
	custompagecustompagesaveinit,
	custompagecustompagelist
} from '@/api/material'
import {
	imgHost
} from "@/utils/config"
import {
	productCategory,
	productpopoverproductlist
} from '@/api/supplier'
import qrCode from '@/components/qrCode.vue';
import merge from 'webpack-merge'

import {
	activityCouponactivityCouponPageInit,
} from "@/api/finance"
@Component({
	name: '',
	components: {
		PageFooter,
		leftmode,
		centermode,
		rightmode,
		ChoosePages,
		qrCode
	}
})

export default class ProductList extends Vue {
	private pageloading = false
	private data: any = [
		{ value: 0, Id: 0, content: '拾物Zone', share: '', name: '页面设置', key: Math.random() + '', BackColor: '#ffffff', moduleName: '拾物Zone' }
	]
	private editmsg: any = {
		msg: {},
		moveindex: -1,
	}
	private list = [
		{ value: 6, link: 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/rt-search2.png', name: '搜索组件' },
		{ value: 1, link: 'http://cdn2024.shiwuzone.com/routuan/image/bulletinboard.png', name: '公告栏' },
		{ value: 2, link: 'http://cdn2024.shiwuzone.com/routuan/image/img-navigation.png', name: '图片导航' },
		{ value: 3, link: 'http://cdn2024.shiwuzone.com/routuan/image/hotzone-link.png', name: '热区链接' },
		{ value: 7, link: 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/specialzone.png', name: '专区组件' },
		{ value: 4, link: 'http://cdn2024.shiwuzone.com/routuan/image/shop-mode.png', name: '商品模块' },
		{ value: 8, link: 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/dailypackage.png', name: '每日团品' },
		{ value: 5, link: 'http://cdn2024.shiwuzone.com/routuan/image/video-mode.png', name: '视频模块' },
		{ value: 9, link: 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/ef6618209a5278956c3b94e47c0c1d1.png', name: '定位菜单' },
		{ value: 10, link: 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/31fa2d436aae4ecb8b64c893b1b1fb5.png', name: '优惠券' },
		{ value: 11, link: 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/300b59698cfd5cfd8a6e9fcb92a1469.png', name: '秒杀模块' },
		{ value: 12, link: 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/9b232669aff801411925b32536ac092.png', name: '分类商品' },
	]
	private olddata: any = {}
	private defaultimg = '/image/1677658403671.png'
	private calssitylist: any = []
	private pagelist: any = []
	private showcode = false
	private codemsg: any = {}
	private shoplist: any = []
	private couponlist: any = []

	@Provide('information') information = this.data
	@Provide('editinfo') editinfo = this.editmsg
	private mounted() {
		this.editinfo.msg = this.data[0]
		if ((this as any).$route.query.Id) {
			this.getdata()
		}
	}


	private setData(e) {
		this.data = e
		this.data.map((v, i) => {
			this.$set(this.information, i, v)
		})
	}
	private async getdata() {
		try {
			this.pageloading = true
			let data = {
				Id: (this as any).$route.query.Id || 0
			}
			let res = await custompagecustompagesaveinit(data)
			if (res.IsSuccess) {
				this.olddata = res.Result
				let title = {
					content: res.Result.PageName,
					share: res.Result.ShareImgUrl,
					BackColor: res.Result.BackColor,
					value: 0,
					key: Math.random() + '',
					name: '页面设置'
				}
				let contentdata: any = []
				if (res.Result.DecorateData) {
					// console.log(JSON.parse(res.Result.DecorateData),123)
					contentdata = JSON.parse(res.Result.DecorateData)

					let classifyIds = [];
					let productIds = [];
					let pageIds = [];
					contentdata.map(item => {
						if (item.value == 2 || item.value == 3) {
							if (item.imglist && item.imglist.length) {
								item.imglist.map(obj => {
									if (obj.pagetype == 2) {
										classifyIds.push(obj.Id)
									}
									if (obj.pagetype == 3) {
										productIds.push(obj.Id)
									}
									if (obj.pagetype == 4) {
										pageIds.push(obj.Id)
									}
								})
							}
						}
						if (item.value == 11) {
							item.list.map(obj => {
								productIds.push(obj)
							})
						}
						if (item.value == 8) {
							for (let k in item.someDayData){
								item.someDayData[k].map(product=>{
									if (product.type == 1){
										productIds.push(product.Id)
									}else{
										product.products.map(product1=>{
											productIds.push(product1.Id)
										})
									}
								})
							}
							// let list = [
							// 	...item.theDayBeforeYesterday​​,
							// 	...item.yesterday​​,
							// 	...item.today,
							// 	...item.​tomorrow​​
							// ];
							// list.map(product=>{
							// 	if (product.type == 1){
							// 		productIds.push(product.Id)
							// 	}else{
							// 		product.products.map(product1=>{
							// 			productIds.push(product1.Id)
							// 		})
							// 	}
							// })
						}
					})

					if (classifyIds.length) {
						await this.getcalssity(classifyIds)
					}
					if (productIds.length) {
						await this.gettablelist(productIds)
					}
					if (pageIds.length) {
						await this.getpagelist(pageIds)
					}

					// if(contentdata.some(v=>v.value==2||v.value==3||v.value==11)){
					//   await this.getcalssity()
					//   await this.getpagelist()
					//   await this.gettablelist()
					// }
					if (contentdata.some(v => v.value == 10)) {
						await this.getcouponlist()
					}
					for (let v of contentdata) {
						let nameObj = this.list.find(x => v.value == x.value)
						if (nameObj && nameObj.value) {
							v.moduleName = v.moduleName || nameObj.name
						}
						if (v.value == 2 || v.value == 3) {
							if (v.imglist && v.imglist.length) {
								v.imglist = v.imglist.map(a => {
									if (a.pagetype == 2) {
										let msg = this.calssitylist.find(m => m.Id == a.Id)
										if (!msg?.Id) {
											return {
												url: a.url
											}
										}
									} else if (a.pagetype == 3) {
										let msg = this.shoplist.find(m => m.Id == a.Id)
										if (!msg?.Id) {
											return {
												url: a.url
											}
										}
									} else if (a.pagetype == 4) {
										let msg = this.pagelist.find(m => m.Id == a.Id)
										if (!msg?.Id) {
											return {
												url: a.url
											}
										}
									}
									return a
								})
							}
						} else if (v.value == 4) {
							let list = res.Result.CustomPageProductModels.find(x => x.Key == v.key).Products || []
							v.list = list.map(z => {
								z.ImgUrlComplete = imgHost + z.MainImgUrl
								return z
							})
						} else if (v.value == 10) {
							v.list = v.list.filter(z => {
								return this.couponlist.some(x => x.Id == z.Id)
							}).map(z => {
								let newz = this.couponlist.find(n => n.Id == z.Id)
								if (newz.DerateMoney == parseInt(newz.DerateMoney)) {
									newz.beforePrice = newz.DerateMoney
									newz.afterPrice = null
								} else {
									[newz.beforePrice, newz.afterPrice] = String(newz.DerateMoney).split('.')
								}
								if (newz.ValidType == 0) {
									newz.timelimit = newz.StartTime + '~' + newz.EndTime
								} else if (newz.ValidType == 1) {
									newz.timelimit = `领取后${newz.ValidTime}天内`
								} else {
									newz.timelimit = `领取后次日起${newz.ValidTime}天内`
								}
								return newz
							})
						} else if (v.value == 11) {
							v.list = v.list.map(m => {
								let msg = this.shoplist.find(x => x.Id == m)
								if (msg) {
									m = msg
									let pri = m.GroupPrice.toFixed(2).split('.')
									m.pointLeft = pri[0]
									m.pointRight = pri[1]
									if (m.pointRight.substring(1, 1) == '0' || m.pointRight.substring(1, 1) == '') {
										m.pointRight = m.pointRight.substring(0, 1)
									}
									return m
								} else {
									return {}
								}
							}).filter(m => m.Id)
							// console.log(v.list)
						} else if (v.value == 8) {

							if (v.someDayData === undefined){
								v.someDayData = {};
								v.dateType = 3;
							}
							for (let k in v.someDayData){
								let array = [];
								v.someDayData[k].map(m=>{
									if (m.type == 1){
										let msg = this.shoplist.find(x => x.Id == m.Id);
										if (msg){
											array.push(
												{
													...m,
													...msg
												}
											) 
										}
									}else{
										let products = []
										m.products.map(n=>{
											let msg = this.shoplist.find(x => x.Id == n.Id);
											if (msg){
												products.push(msg)
											}
										})
										m.products = products;
										m.tags = m.tags || [];
										array.push(m)
									}
								})
								v.someDayData[k] = array;
							}

						}
						v.key = v.key || (Math.random() + '')
					}
				}
				this.data = [
					title, ...contentdata
				]
				this.$set(this.editmsg, 'msg', title)
				this.data.map((v, i) => {
					this.$set(this.information, i, v)
				})
				console.log(this.data)

			}
		} finally {
			this.pageloading = false
		}
	}
	private async getcouponlist() {
		try {
			let res: any = await activityCouponactivityCouponPageInit({
				Keywords: '',
				Skip: 0,
				Take: 99999
			})
			if (res.IsSuccess) {
				this.couponlist = res.Result.Results
			}
		} finally {
			//
		}
	}
	private async confirm(e) {
		if (e.type == 'save') {
			this.save(e.Isrelease)
		} else if (e.type == 'preview') {
			this.preview()
		}
	}
	private async preview() {
		await this.save(false, true)
		setTimeout(() => {
			this.codemsg = {
				type: 3,
				Id: this.$route.query.Id,
				title: this.information.find(v => v.value == 0).content
			}
			this.showcode = true
		}, 1000)
	}
	private async save(e, nomsg?: boolean) {
		try {
			this.pageloading = true
			let title = this.information.find(v => v.value == 0)
			let strdata = JSON.parse(JSON.stringify(this.information.filter(v => v.value != 0)))
			let DecorateData: any = []
			if (strdata && strdata.length) {
				DecorateData = JSON.stringify(strdata.map((v, i) => {
					// console.log(v)

					if (v.value == 4 && v.list && v.list.length) {
						v.list = v.list.map(x => x.Id)
					}
					if (v.value == 9) {
						v.underModule = this.getunderModule(i)
						// console.log(v)
						v.menuList = v.menuList.map(m => {
							let keyObj = v.underModule.find(x => x.key == m.key)
							m.key = (keyObj && keyObj.key) ? keyObj.key : ''
							return m
						})
					}
					if (v.value == 8) {
						v.shoplist = [];
						for(let k in v.someDayData){
							v.someDayData[k] = v.someDayData[k].map(item=>{
								if (item.type === 1) {
									return {
										Id: item.Id,
										tag: item.tag || '',
										type: 1
									}
								} else {
									item.products = item.products.map(product => {
										return {
											Id: product.Id
										}
									})
									return item
								}
							})
						}
						
					}
					if (v.value == 11 && v.list && v.list.length) {
						v.list = v.list.map(x => x.Id)
					}
					return v
				}))
			}
			// console.log(DecorateData)
			// return
			let data: any = {
				Id: this.olddata.Id || 0,
				PageName: title.content,
				ShareImgUrl: title.share,
				BackColor: title.BackColor,
				DecorateData: DecorateData,
				IsRelease: e,
			}
			// console.log(data,'savedata')
			// return
			let res = await custompagecustompagesave(data)
			if (res.IsSuccess) {
				if (!nomsg) {
					this.$message.success('操作成功')
				}
				(this as any).$router.push({
					query: merge(this.$route.query, {
						Id: res.Result.Id
					})
				}, () => { }, () => { })
				setTimeout(() => {
					this.getdata()
				}, 500)
			}
		} finally {
			this.pageloading = false
		}
	}
	private getunderModule(e) {
		let under = this.information.filter((v, i) => {
			return e < i - 1
		})
		// console.log(under)
		return under
	}
	//商品分类
	private async getcalssity(list) {
		let params: any = {
			Skip: 0,
			Take: 99999,
			Keywords: '',
			IdList: list
		}
		try {
			const res: any = await productCategory(params);
			if (res.IsSuccess) {
				this.calssitylist = res.Result.Results
			}
		} finally {
			//
		}
	}
	//自定义页面列表
	private async getpagelist(list) {
		try {
			let data: any = {
				PageName: '',
				Skip: 0,
				Take: 99999,
				IdList: list
			}
			let res: any = await custompagecustompagelist(data)
			if (res.IsSuccess) {
				this.pagelist = res.Result.Results
			}
		} finally {
			//
		}
	}
	//商品列表
	private async gettablelist(list) {
		let dt = new Date();
		let year = dt.getFullYear();
		let month = dt.getMonth();
		let day = dt.getDate();
		try {
			let data: any = {
				Skip: 0,
				Take: 99999,
				Keywords: '',
				ProductCategoryId: '',
				ProductIdList: list,
				// StartTime: new Date(year, month, day-180).toLocaleDateString(),
				// EndTime: new Date(year, month, day+1).toLocaleDateString(),
			}
			let res = await productpopoverproductlist(data)
			if (res.IsSuccess) {
				this.shoplist = res.Result.Results
			}
		} finally {
			//
		}
	}
}
